import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { Link } from 'react-router-dom';
import FormViewGrid from 'components/atoms/form/FormViewGrid';
import FormHeading from 'components/atoms/form/FormHeading';
import { Tab, TabList } from 'components/atoms/tabs';

class BrandTabView extends Component {
    render() {
        const brandName = get(this.props, 'brand.name', null);
        const brandId = get(this.props, 'brand.id', null);
        const editBrandLink = (
            <Link to={`/admin/brands/${brandId}/edit`} title="Edit Brand">
                <span className="icon-edit" />
            </Link>
        );

        return (
            <FormViewGrid fluid>
                <FormHeading>
                    {brandName}
                    {brandId && editBrandLink}
                </FormHeading>
                <TabList>
                    <Tab selected={this.props.selected === 'view'} onClick={() => this.props.push(`/admin/brands/${brandId}`)}>Info</Tab>
                    <Tab selected={this.props.selected === 'branding'} onClick={() => this.props.push(`/admin/brands/${brandId}/branding`)}>Branding</Tab>
                    <Tab selected={this.props.selected === 'options'} onClick={() => this.props.push(`/admin/brands/${brandId}/options`)}>Advanced Options</Tab>
                </TabList>
                {this.props.children}
            </FormViewGrid>
        );
    }
}

BrandTabView.propTypes = {
    selected: PropTypes.string,
    brand: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string
    }),
    push: PropTypes.func
};

export default BrandTabView;



// WEBPACK FOOTER //
// ./src/components/organisms/brand/BrandTabView.js